{
  "Monday": "Maandag",
  "Mondayshort": "maandag",
  "Tuesday": "Dinsdag",
  "Tuesdayshort": "di",
  "Wednesday": "Woensdag",
  "Wednesdayshort": "wo",
  "Thursday": "Donderdag",
  "Thursdayshort": "do",
  "Friday": "Vrijdag",
  "Fridayshort": "vrij",
  "Saturday": "zaterdag",
  "Saturdayshort": "Za",
  "Sunday": "Zondag",
  "Sundayshort": "Zon",
  "NAME": "DaysOfTheWeek"
}